export default {
  routes: [
    {
      name: 'main-page',
      path: '/',
      component: () => import('./views/TheMainPage.vue'),
    }
  ]
}
